<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <div class="cell shrink grid-x grid-margin-x grid-margin-y">
        <table class="cell xsmall-12">
            <thead>
            <tr class="_titlePartTable">
                <th colspan="2"[i18nKey]="'quality.dishes.wines'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'quality.dishesQuality'"></td>
                <td class="_number">
                    {{study.qualityResult.menuQuality.dishesQuality | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.winesQuality'"></td>
                <td class="_number">
                    {{study.qualityResult.menuQuality.winesQuality | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.mark'"></td>
                <td class="_number">
                    <kiwi-number-or-nothing [displayValue]="study.qualityResult.menuQuality.weight > 0"
                                            [valueToDisplay]="study.qualityResult.menuQuality.mark">
                    </kiwi-number-or-nothing>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.dishes.mark'"></td>
                <td class="_number">
                    {{study.qualityResult.menuQuality.totalMenuQuality | number:'1.2'}}
                </td>
            </tr>
        </table>
        <table class="cell xsmall-12">
            <thead>
            <tr class="_titlePartTable">
                <th colspan="2"[i18nKey]="'quality.advertising'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'quality.notoriety'"></td>
                <td class="_number">
                    {{study.qualityResult.advertisementQuality.qualityInducedByBudget | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.image'"></td>
                <td class="_number">
                    {{study.qualityResult.advertisementQuality.qualityInducedByAxes | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.mark'"></td>
                <td class="_number">
                    <kiwi-number-or-nothing [displayValue]="study.qualityResult.advertisementQuality.weight > 0"
                                            [valueToDisplay]="study.qualityResult.advertisementQuality.mark">
                    </kiwi-number-or-nothing>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.advertising.mark'"></td>
                <td class="_number">
                    {{study.qualityResult.advertisementQuality.totalAdvertisementQuality | number:'1.2'}}
                </td>
            </tr>
        </table>
        <table class="cell xsmall-12">
            <thead>
            <tr class="_titlePartTable">
                <th colspan="2" class="qualityTable-column"[i18nKey]="'quality.cooking.quality'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'quality.salary.mass'"></td>
                <td class="_number">
                    {{study.qualityResult.cookingQuality.staffQuality | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.hierarchy'"></td>
                <td class="_number">
                    <kiwi-number-or-nothing [displayValue]="study.displayHierarchyQualities"
                                            [valueToDisplay]="study.qualityResult.cookingQuality.hierarchyQuality">
                    </kiwi-number-or-nothing>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.mark'"></td>
                <td class="_number">
                    <kiwi-number-or-nothing [displayValue]="study.qualityResult.cookingQuality.weight > 0"
                                            [valueToDisplay]="study.qualityResult.cookingQuality.mark">
                    </kiwi-number-or-nothing>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.cooking.quality.mark'"></td>
                <td class="_number">
                    {{study.qualityResult.cookingQuality.totalQuality | number:'1.2'}}
                </td>
            </tr>
        </table>
        <table class="cell xsmall-12">
            <thead>
            <tr class="_titlePartTable">
                <th colspan="2" class="qualityTable-column"[i18nKey]="'quality.customerCare.quality'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'quality.salary.mass'"></td>
                <td class="_number">
                    {{study.qualityResult.customerCareQuality.staffQuality | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.hierarchy'"></td>
                <td class="_number">
                    <kiwi-number-or-nothing [displayValue]="study.displayHierarchyQualities"
                                            [valueToDisplay]="study.qualityResult.customerCareQuality.hierarchyQuality">
                    </kiwi-number-or-nothing>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.mark'"></td>
                <td class="_number">
                    <kiwi-number-or-nothing [displayValue]="study.qualityResult.customerCareQuality.weight > 0"
                                            [valueToDisplay]="study.qualityResult.customerCareQuality.mark">
                    </kiwi-number-or-nothing>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.customerCare.quality.mark'"></td>
                <td class="_number">
                    {{study.qualityResult.customerCareQuality.totalQuality | number:'1.2'}}
                </td>
            </tr>
        </table>
        <table class="cell xsmall-12">
            <thead>
            <tr class="_titlePartTable">
                <th colspan="2" class="qualityTable-column"[i18nKey]="'quality.equipments'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'quality.equipments.quality'"></td>
                <td class="_number">
                    {{study.qualityResult.layoutQuality | number:'1.2'}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.layout.mark'"></td>
                <td class="_number">{{study.qualityResult.layoutQuality | number:'1.2'}}</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            </tbody>
        </table>
        <table class="cell xsmall-12">
            <thead>
            <tr class="_titlePartTable">
                <th colspan="2" class="qualityTable-column"[i18nKey]="'quality.maintenance'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'quality.maintenance.budget'"></td>
                <td class="_number">
                    {{study.qualityResult.maintenanceQuality.maintenanceBudgetPerRoom | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.maintenance.budget.effective'"></td>
                <td class="_number">
                    {{study.qualityResult.maintenanceQuality.effectiveMaintenanceBudgetPerRoom | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'quality.maintenance.mark'"></td>
                <td class="_number">
                    {{study.qualityResult.maintenanceQuality.totalMaintenanceQuality | number:'1.2'}}
                </td>
            </tr>
        </table>
    </div>

    <p [i18nKey]="'quality.increased.weights.explanation'"></p>

    <kiwi-spacer [size]="32"></kiwi-spacer>

    <div class="cell shrink qualityResult">
        <span class="qualityResult-label"[i18nKey]="'quality.totalQuality'"></span>
        <span class="qualityResult-value"> {{study.qualityResult.totalQuality | number:'1.2'}}</span>
    </div>
</div>
